module.exports = __webpack_public_path__ + "static/img/personTwo.2d571c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/welcome/personTwo.png
// module id = kP3O
// module chunks = 1